

import { BaseAjaxSave } from "../../../../assets/js/common/shared_service";

export default class productProcurementUpdate{
    constructor(){
        this.productProcuremenFormUpdate = document.querySelector('#productProcuremenFormUpdate');
        if(!this.productProcuremenFormUpdate) return;
        this.event();
    }
    event(){
        this.productProcuremenFormUpdate.addEventListener('submit', (event) => {
            BaseAjaxSave(event);
        });
    }

}